import AppConfig from './common/DomainConfiguration';

// English translations
const ENGLISH = {
    //Keywords
    REMENBER_ME: 'rememberMe',
    ADMIN: 'ADMIN',
    INSADMIN: 'GRA_ADMIN',
    INS_ADMIN: 'INSADMIN',
    BRANCHADMIN: 'LEVEL_THREE_ADMIN',
    LEVEL_ONE_ADMIN: 'LEVEL_ONE_ADMIN',
    LEVEL_TWO_ADMIN: 'LEVEL_TWO_ADMIN',
    TUTOR_UNAVAILABLE: 'No Owners available',
    NOT_ASSIGNED: 'Not Assigned',
    CREATED_REFERRAL_UNAVAILABLE: 'No Referral Created ',
    RECEIVED_REFERRAL_UNAVAILABLE: 'No Referral Received',
    COMPLETED_REFERRAL_UNAVAILABLE: 'No Referral Completed',
    STUDENT_UNAVAILABLE: 'No Team Members available',
    STUDENT_BATCH_UPLOAD_UNAVAILABLE: 'No upload history available',
    SESSIONS_UNAVAILABLE: 'No Sessions available',
    REQUEST_UNAVAILABLE: 'No Requests available',
    SUBJECT_UNAVAILABLE: 'No Channels available',
    SUBCATEGORY_UNAVAILABLE: 'No Elements available',
    WARNING: 'warning',
    ERROR: 'error',
    SUCCESS: 'success',
    ADMIN_RECEIVED_BACKGROUND_CHECK_REPORT: 'ADMIN_RECEIVED_BACKGROUND_CHECK_REPORT',
    INVALID_EMAIL: 'Invalid Email',
    APPOINTMENT_CONFIRMATION: 'APPOINTMENT_CONFIRMATION',
    TUTOR_VERIFICATION: 'TUTOR_VERIFICATION',
    APPOINTMENT_CANCEL: 'APPOINTMENT_CANCEL',
    APPOINTMENT_REMAINDER: 'APPOINTMENT_REMAINDER',
    APPOINTMENT_MISSED: 'APPOINTMENT_MISSED',
    CLASSROOM_CONFIRMATION: 'CLASSROOM_CONFIRMATION',
    APPOINTMENT_WAITING_ROOM: 'APPOINTMENT_WAITING_ROOM',
    CLASSROOM_CANCEL: 'CLASSROOM_CANCEL',
    CLASSROOM_REMAINDER: 'CLASSROOM_REMAINDER',
    REFERRAL_NOTIFICATION: 'REFERRAL_NOTIFICATION',
    SUBJECT_REFERRAL_NOTIFICATION: 'SUBJECT_REFERRAL_NOTIFICATION',
    BROADCAST_CONFIRMATION: 'BROADCAST_CONFIRMATION',
    BROADCAST_CANCEL: 'BROADCAST_CANCEL',
    BROADCAST_REMAINDER: 'BROADCAST_REMAINDER',
    APPOINTMENT_REFUND: 'APPOINTMENT_REFUND',
    LEVEL_UNAVAILABLE: 'No Level available',
    IN_PERSON_CONFIRMATION: 'IN_PERSON_CONFIRMATION',
    // educator/admin new messages reg flag session
    MORE_INFO_NEEDED: 'More Info Needed',
    MORE_INFO_PROVIDED: 'More Info Provided',
    ACTION_TAKEN: 'Action Taken',
    EDUCATOR_FLAGGED_SESSION: 'Under Review',
    STUDENT_NOTES: 'COLLABORATOR_NOTES',
    //Status Code
    SUCCESS_CODE: 200,
    EXISTING_NAME_CODE: 417,
    //string values
    CANCELATION_REASON_EMPTY: 'Reason is mandatory',
    CATEGORY_MANDATORY: 'Element is mandatory',
    FLAG_STATUS: 'Other element is mandatory',
    FLAGGING_STATUS: 'Status is mandatory',
    //Validation message
    ENTER_EMAIL_ADDRESS: 'Enter email address',
    ENTER_PASSWORD: 'Enter Password',
    ENTER_CONFIRM_PASSWORD: 'Enter Confirm password',
    SOMETHING_WENT_WRONG: 'Something went wrong, Please try again later',
    LEVEL_MANDATORY: 'Level is Mandatory',
    START_TIME_MANDATORY: 'Start time should not be empty',
    END_TIME_MANDATORY: 'End time should not be empty',
    START_AND_END_TIME_NOT_SAME: 'Start time and End time should not be same',
    START_AND_END_TIME_MANDATORY: 'Start time and End time should not be empty',
    MINUMUM_SLOT_DURATION: 'Slot time should be minimum 15 minutes',
    END_TIME_LESS_THAN_START_TIME: 'Please select an end time greater than start time',
    DAY_MANDATORY: 'Days should not be empty',
    SELECT_DATE_TIME: 'Select date and timing',
    //Error Message
    TRYAGAIN: 'Try again...',
    //RESPONSE MESSAGE
    SUB_SUBJECT_MISSING: 'Element name is missing',
    SUB_CATEGORY_NAME_MISSING: 'Please enter atleast one element',
    PARENT_NAME_MISSING: 'Please enter Parent subject',
    SUB_SUBJECT_MANDATORY: 'Element is Mandatory',
    EDUCATOR_MANDATORY: 'Owner is Mandatory',
    STUDENT_MANDATORY: 'Team Member is Mandatory',
    STUDENT_LIMIT: 'The broadcast session can be scheduled for a maximum of 300 Team Members',
    UPLOAD_ONLY_IMAGE: 'Please upload only Image/PDF',
    MEDIA_FILE_SIZE: 'Upload a Image/PDF less than 10 MB',
    MEDIA_TOTAL_SIZE_EXCEEDED: 'Upload a Image/PDF less than 50 MB',
    HYPHEN: '-',
    COMMA: ',',
    EMPTY: '',
    BROADCAST: 'broadcast',
    REGISTERED: 'REGISTERED',
    START_TIME_ALERT: 'Start time should be less than End time',
    FIRSTNAME_LASTNAME_REQUIRED: "First name and last name are required",
    MAX_EMAIL_LIMIT: 'Maximum {count} email addresses allowed',
    EMAIL_ALREADY_ADDED: 'Email already added',
    APPOINTMENT_RESCHEDULED: 'APPOINTMENT_RESCHEDULED',
};

// Spanish translations
const SPANISH = {
    //Keywords
    REMENBER_ME: 'rememberMe',
    ADMIN: 'ADMIN',
    INSADMIN: 'GRA_ADMIN',
    INS_ADMIN: 'INSADMIN',
    BRANCHADMIN: 'LEVEL_THREE_ADMIN',
    LEVEL_ONE_ADMIN: 'LEVEL_ONE_ADMIN',
    LEVEL_TWO_ADMIN: 'LEVEL_TWO_ADMIN',
    TUTOR_UNAVAILABLE: 'No hay Propietarios disponibles',
    NOT_ASSIGNED: 'No Asignado',
    CREATED_REFERRAL_UNAVAILABLE: 'No se Creó Referencia ',
    RECEIVED_REFERRAL_UNAVAILABLE: 'No se Recibió Referencia',
    COMPLETED_REFERRAL_UNAVAILABLE: 'No se Completó Referencia',
    STUDENT_UNAVAILABLE: 'No hay Miembros del Equipo disponibles',
    STUDENT_BATCH_UPLOAD_UNAVAILABLE: 'No hay historial de carga disponible',
    SESSIONS_UNAVAILABLE: 'No hay Sesiones disponibles',
    REQUEST_UNAVAILABLE: 'No hay Solicitudes disponibles',
    SUBJECT_UNAVAILABLE: 'No hay Canales disponibles',
    SUBCATEGORY_UNAVAILABLE: 'No hay Elementos disponibles',
    WARNING: 'warning',
    ERROR: 'error',
    SUCCESS: 'success',
    ADMIN_RECEIVED_BACKGROUND_CHECK_REPORT: 'ADMIN_RECEIVED_BACKGROUND_CHECK_REPORT',
    INVALID_EMAIL: 'Correo Electrónico Inválido',
    APPOINTMENT_CONFIRMATION: 'APPOINTMENT_CONFIRMATION',
    TUTOR_VERIFICATION: 'TUTOR_VERIFICATION',
    APPOINTMENT_CANCEL: 'APPOINTMENT_CANCEL',
    APPOINTMENT_REMAINDER: 'APPOINTMENT_REMAINDER',
    APPOINTMENT_MISSED: 'APPOINTMENT_MISSED',
    CLASSROOM_CONFIRMATION: 'CLASSROOM_CONFIRMATION',
    APPOINTMENT_WAITING_ROOM: 'APPOINTMENT_WAITING_ROOM',
    CLASSROOM_CANCEL: 'CLASSROOM_CANCEL',
    CLASSROOM_REMAINDER: 'CLASSROOM_REMAINDER',
    REFERRAL_NOTIFICATION: 'REFERRAL_NOTIFICATION',
    SUBJECT_REFERRAL_NOTIFICATION: 'SUBJECT_REFERRAL_NOTIFICATION',
    BROADCAST_CONFIRMATION: 'BROADCAST_CONFIRMATION',
    BROADCAST_CANCEL: 'BROADCAST_CANCEL',
    BROADCAST_REMAINDER: 'BROADCAST_REMAINDER',
    APPOINTMENT_REFUND: 'APPOINTMENT_REFUND',
    LEVEL_UNAVAILABLE: 'No hay Nivel disponible',
    IN_PERSON_CONFIRMATION: 'IN_PERSON_CONFIRMATION',
    // educator/admin new messages reg flag session
    MORE_INFO_NEEDED: 'Se Necesita Más Información',
    MORE_INFO_PROVIDED: 'Más Información Proporcionada',
    ACTION_TAKEN: 'Acción Tomada',
    EDUCATOR_FLAGGED_SESSION: 'Bajo Revisión',
    STUDENT_NOTES: 'COLLABORATOR_NOTES',
    //Status Code
    SUCCESS_CODE: 200,
    EXISTING_NAME_CODE: 417,
    //string values
    CANCELATION_REASON_EMPTY: 'La razón es obligatoria',
    CATEGORY_MANDATORY: 'El elemento es obligatorio',
    FLAG_STATUS: 'Otro elemento es obligatorio',
    FLAGGING_STATUS: 'El estado es obligatorio',
    //Validation message
    ENTER_EMAIL_ADDRESS: 'Ingrese dirección de correo electrónico',
    ENTER_PASSWORD: 'Ingrese Contraseña',
    ENTER_CONFIRM_PASSWORD: 'Ingrese Confirmar contraseña',
    SOMETHING_WENT_WRONG: 'Algo salió mal, Por favor intente más tarde',
    LEVEL_MANDATORY: 'El Nivel es Obligatorio',
    START_TIME_MANDATORY: 'La hora de inicio no debe estar vacía',
    END_TIME_MANDATORY: 'La hora de finalización no debe estar vacía',
    START_AND_END_TIME_NOT_SAME: 'La hora de inicio y finalización no deben ser iguales',
    START_AND_END_TIME_MANDATORY: 'La hora de inicio y finalización no deben estar vacías',
    MINUMUM_SLOT_DURATION: 'El tiempo del espacio debe ser mínimo 15 minutos',
    END_TIME_LESS_THAN_START_TIME:
        'Por favor seleccione una hora de finalización mayor que la hora de inicio',
    DAY_MANDATORY: 'Los días no deben estar vacíos',
    SELECT_DATE_TIME: 'Seleccione fecha y hora',
    //Error Message
    TRYAGAIN: 'Intentar de nuevo...',
    //RESPONSE MESSAGE
    SUB_SUBJECT_MISSING: 'Falta el nombre del elemento',
    SUB_CATEGORY_NAME_MISSING: 'Por favor ingrese al menos un elemento',
    PARENT_NAME_MISSING: 'Por favor ingrese la materia principal',
    SUB_SUBJECT_MANDATORY: 'El Elemento es Obligatorio',
    EDUCATOR_MANDATORY: 'El Propietario es Obligatorio',
    STUDENT_MANDATORY: 'El Miembro del Equipo es Obligatorio',
    STUDENT_LIMIT:
        'La sesión de difusión puede ser programada para un máximo de 300 Miembros del Equipo',
    UPLOAD_ONLY_IMAGE: 'Por favor cargue solo Imagen/PDF',
    MEDIA_FILE_SIZE: 'Cargue una Imagen/PDF de menos de 10 MB',
    MEDIA_TOTAL_SIZE_EXCEEDED: 'Cargue una Imagen/PDF de menos de 50 MB',
    HYPHEN: '-',
    COMMA: ',',
    EMPTY: '',
    BROADCAST: 'broadcast',
    REGISTERED: 'REGISTERED',
    START_TIME_ALERT: 'La hora de inicio debe ser menor que la hora de finalización',
    APPOINTMENT_RESCHEDULED: 'APPOINTMENT_RESCHEDULED',
};

// Helper function to get domain-specific translations
const getDomainTranslation = (key, lang) => {
    const translations = {
        en: {
            SUBJECT_MANDATORY: `${AppConfig.labels.channel} is Mandatory`,
            SUBJECT_NAME_MISSING: `${AppConfig.labels.channel} name is missing`,
        },
        es: {
            SUBJECT_MANDATORY: `${AppConfig.labels.channel} es Obligatorio`,
            SUBJECT_NAME_MISSING: `Falta el nombre de ${AppConfig.labels.channel}`,
        },
    };
    return translations[lang]?.[key];
};

// Export RESPONSE_CONSTANT with dynamic language support
export const RESPONSE_CONSTANT = new Proxy(
    {},
    {
        get(target, prop) {
            const lang = AppConfig.appLanguage || 'en';

            // Check if this is a domain-specific key
            const domainTranslation = getDomainTranslation(prop, lang);
            if (domainTranslation !== undefined) {
                return domainTranslation;
            }

            // Return language-specific translation
            return lang === 'es' ? SPANISH[prop] : ENGLISH[prop];
        },
    }
);
